var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:{
		'btn keyword': true,
		active: _vm.active,
		hidden: !_vm.keyword.isVisible,
	},attrs:{"type":"button","title":`${_vm.$t('common.Keyword')} '${_vm.keyword.keyword_display}' (${_vm.$t('common.concept')} '${_vm.keyword.concept_display}')` + '\n\n' + _vm.tooltip}},[_c('span',{class:'keyword-icon fa '+_vm.keyword.class,style:({color: _vm.keyword.color, fontSize: Math.sqrt(_vm.keyword.iconSize) + 'em'})}),_vm._v(" "+_vm._s(_vm.keyword.display)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }